import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const StylusSvg = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.7341 11.6068C15.4445 11.8965 14.975 11.8965 14.6854 11.6068L14.5219 11.4433L12.9384 14.3057C12.6997 14.7372 12.2821 15.0564 11.8171 15.1628L3.78651 17L7.26296 13.5236C8.11607 14.0274 9.23327 13.9128 9.96632 13.1799C10.8351 12.3111 10.8351 10.9025 9.96632 10.0338C9.09754 9.16498 7.68891 9.16498 6.82015 10.0338C6.08716 10.7667 5.9726 11.8839 6.47643 12.7371L3 16.2134L4.8372 8.18295C4.94358 7.718 5.2628 7.30037 5.69431 7.06167L8.55668 5.47821L8.39311 5.3146C8.10347 5.02501 8.10347 4.55549 8.39311 4.26589L9.44179 3.21719C9.73143 2.9276 10.2009 2.9276 10.4905 3.21719L16.7828 9.50945C17.0724 9.79902 17.0724 10.2686 16.7828 10.5581L15.7341 11.6068Z"
                    fill="auto"
                />
            </svg>
        </SvgIcon>
    );
};
